// extracted by mini-css-extract-plugin
module.exports = {"content":"job-role-page-module--content--tY-37"};